// --- Canonical PERSONAL profile keyword categories and options (for dropdowns) ---
export const PROFILE_CLUSTER_CATEGORY_ORDER = [
  "citizenship_multi_select",
  "highest_education",
  "ethnicity",
  "languages_spoken",
  "height_range",
  "weight_range",
  "dietary_preferences",
  "allergies",
  "chronic_conditions",
];

export const PERSONAL_PROFILE_KEYWORDS = {
  citizenship_multi_select: [
    "Afghan",
    "Albanian",
    "Algerian",
    "American",
    "Andorran",
    "Angolan",
    "Anguillan",
    "Citizen of Antigua and Barbuda",
    "Argentine",
    "Armenian",
    "Australian",
    "Austrian",
    "Azerbaijani",
    "Bahamian",
    "Bahraini",
    "Bangladeshi",
    "Barbadian",
    "Belarusian",
    "Belgian",
    "Belizean",
    "Beninese",
    "Bermudian",
    "Bhutanese",
    "Bolivian",
    "Citizen of Bosnia and Herzegovina",
    "Botswanan",
    "Brazilian",
    "British",
    "British Virgin Islander",
    "Bruneian",
    "Bulgarian",
    "Burkinan",
    "Burmese",
    "Burundian",
    "Cambodian",
    "Cameroonian",
    "Canadian",
    "Cape Verdean",
    "Cayman Islander",
    "Central African",
    "Chadian",
    "Chilean",
    "Chinese",
    "Colombian",
    "Comoran",
    "Congolese (Congo)",
    "Congolese (DRC)",
    "Cook Islander",
    "Costa Rican",
    "Croatian",
    "Cuban",
    "Cymraes",
    "Cymro",
    "Cypriot",
    "Czech",
    "Danish",
    "Djiboutian",
    "Dominican",
    "Citizen of the Dominican Republic",
    "Dutch",
    "East Timorese",
    "Ecuadorean",
    "Egyptian",
    "Emirati",
    "English",
    "Equatorial Guinean",
    "Eritrean",
    "Estonian",
    "Ethiopian",
    "Faroese",
    "Fijian",
    "Filipino",
    "Finnish",
    "French",
    "Gabonese",
    "Gambian",
    "Georgian",
    "German",
    "Ghanaian",
    "Gibraltarian",
    "Greek",
    "Greenlandic",
    "Grenadian",
    "Guamanian",
    "Guatemalan",
    "Citizen of Guinea-Bissau",
    "Guinean",
    "Guyanese",
    "Haitian",
    "Honduran",
    "Hong Konger",
    "Hungarian",
    "Icelandic",
    "Indian",
    "Indonesian",
    "Iranian",
    "Iraqi",
    "Irish",
    "Israeli",
    "Italian",
    "Ivorian",
    "Jamaican",
    "Japanese",
    "Jordanian",
    "Kazakh",
    "Kenyan",
    "Kittitian",
    "Citizen of Kiribati",
    "Kosovan",
    "Kuwaiti",
    "Kyrgyz",
    "Lao",
    "Latvian",
    "Lebanese",
    "Liberian",
    "Libyan",
    "Liechtenstein citizen",
    "Lithuanian",
    "Luxembourger",
    "Macanese",
    "Macedonian",
    "Malagasy",
    "Malawian",
    "Malaysian",
    "Maldivian",
    "Malian",
    "Marshallese",
    "Martiniquais",
    "Mauritanian",
    "Mauritian",
    "Mexican",
    "Micronesian",
    "Moldovan",
    "Monegasque",
    "Mongolian",
    "Montenegrin",
    "Montserratian",
    "Moroccan",
    "Mosotho",
    "Mozambican",
    "Namibian",
    "Nauruan",
    "Nepalese",
    "New Zealander",
    "Nicaraguan",
    "Nigerian",
    "Nigerien",
    "Niuean",
    "North Korean",
    "Northern Irish",
    "Norwegian",
    "Omani",
    "Pakistani",
    "Palauan",
    "Palestinian",
    "Panamanian",
    "Papua New Guinean",
    "Paraguayan",
    "Peruvian",
    "Pitcairn Islander",
    "Polish",
    "Portuguese",
    "Prydeinig",
    "Puerto Rican",
    "Qatari",
    "Romanian",
    "Russian",
    "Rwandan",
    "Salvadorean",
    "Sammarinese",
    "Samoan",
    "Sao Tomean",
    "Saudi Arabian",
    "Scottish",
    "Senegalese",
    "Serbian",
    "Citizen of Seychelles",
    "Sierra Leonean",
    "Singaporean",
    "Slovak",
    "Slovenian",
    "Solomon Islander",
    "Somali",
    "South African",
    "South Korean",
    "South Sudanese",
    "Spanish",
    "Sri Lankan",
    "St Helenian",
    "St Lucian",
    "Stateless",
    "Sudanese",
    "Surinamese",
    "Swazi",
    "Swedish",
    "Swiss",
    "Syrian",
    "Taiwanese",
    "Tajik",
    "Tanzanian",
    "Thai",
    "Togolese",
    "Tongan",
    "Trinidadian",
    "Tristanian",
    "Tunisian",
    "Turkish",
    "Turkmen",
    "Turks and Caicos Islander",
    "Tuvaluan",
    "Ugandan",
    "Ukrainian",
    "Uruguayan",
    "Uzbek",
    "Vatican citizen",
    "Citizen of Vanuatu",
    "Venezuelan",
    "Vietnamese",
    "Vincentian",
    "Wallisian",
    "Welsh",
    "Yemeni",
    "Zambian",
    "Zimbabwean",
  ],
  highest_education: [
    "High School Certificate",
    "GED (General Educational Development)",
    "Diploma",
    "Associate Degree",
    "Bachelor's Degree",
    "Master's Degree",
    "Doctorate (Ph.D)",
    "Professional Certification",
    "Postdoctoral Fellowship",
    "Professional Degree (e.g., JD, MD, DDS)",
    "Vocational Training",
    "Trade School Certification",
    "Continuing Education Courses",
    "Executive Education Programs",
    "Online Certifications and Courses",
    "Technical diploma",
    "MBA",
    "BTEC",
  ],
  ethnicity: [
    "White - English, Welsh, Scottish, Irish, Gypsy, Roma",
    "White - Any other White background",
    "Local Born - Indian/Hindu",
    "Asian - Indian/Hindu",
    "Local Born - Pakistani/Muslim",
    "Asian - Pakistani/Muslim",
    "Local Born - Chinese",
    "Asian - Chinese",
    "Local Born - Other Asian",
    "Asian - Other",
    "Local Born - Carribean",
    "Black - Carribean",
    "Local Born - African",
    "Black - African",
    "Local Born - Other Black",
    "Black - Other Black",
    "Local Born - Arab",
    "Arab - Other Arab",
    "Mixed - White and Black Caribbean",
    "Mixed - White and Black African",
    "Mixed - White and Asian",
    "Mixed - Black and Asian",
    "Mixed - Arab and Asian",
    "Mixed - Arab and Black",
    "Any other Mixed or multiple ethnic background",
  ],
  languages_spoken: [
    "Swedish",
    "Czech",
    "Zulu",
    "Greek",
    "Hungarian",
    "Somali",
    "Nepali",
    "Serbo-Croatian",
    "Kurdish",
    "Dutch",
    "Romanian",
    "Amharic",
    "Sindhi",
    "Uzbek",
    "Yoruba",
    "Tagalog",
    "Ukrainian",
    "Burmese",
    "Hausa",
    "Malayalam",
    "Kannada",
    "Pashto",
    "Polish",
    "Persian",
    "Gujarati",
    "Thai",
    "Cantonese",
    "Italian",
    "Turkish",
    "Urdu",
    "Tamil",
    "Marathi",
    "French",
    "Korean",
    "Vietnamese",
    "Telugu",
    "Indonesian",
    "Javanese",
    "German",
    "Punjabi",
    "Japanese",
    "Russian",
    "Bengali",
    "Portuguese",
    "Arabic",
    "Hindi",
    "English",
    "Spanish",
    "Mandarin",
    "Malay",
    "Swahili",
    "Hausa",
    "Amharic",
    "Yoruba",
    "Oromo",
    "Igbo",
    "Nilo-Saharan languages",
    "Niger–Congo languages",
    "Afroasiatic",
    "Khoisan",
    "Xhosa",
    "Somali",
    "Austronesian",
    "Afrikaans",
    "Afrikaans",
    "Somali",
    "Fula",
    "Sesotho",
    "Swiss",
    "Filipino",
  ],
  height_range: [
    "Below 100 cm (3'1\")",
    "100 - 119 cm (3'1\" - 3'5\")",
    "110 - 119 cm (3'5\" - 3'9\")",
    "120 - 129 cm (3'9\" - 4'3\")",
    "130 - 139 cm (4'3\" - 4'7\")",
    "140 - 149 cm (4'7\" - 4'11\")",
    "150 - 159 cm (4'11\" - 5'3\")",
    "160 - 164 cm (5'3\" - 5'5\")",
    "165 - 169 cm (5'5\" - 5'7\")",
    "170 - 174 cm (5'7\" - 5'9\")",
    "175 - 179 cm (5'9\" - 5'11\")",
    "180 - 184 cm (5'11\" - 6'1\")",
    "185 - 189 cm (6'1\" - 6'3\")",
    "190 - 194 cm (6'3\" - 6'5\")",
    "195 - 199 cm (6'5\" - 6'7\")",
    "200 - 204 cm (6'7\" - 6'9\")",
    "205 - 209 cm (6'9\" - 6'10\")",
    "210 cm and above (6'11\"+)",
  ],
  weight_range: [
    "Below 20 kg (Below 44 lbs)",
    "20 - 29 kg (44 - 64 lbs)",
    "30 - 39 kg (66 - 86 lbs)",
    "40 - 49 kg (88 - 108 lbs)",
    "50 - 59 kg (110 - 130 lbs)",
    "60 - 69 kg (132 - 152 lbs)",
    "70 - 79 kg (154 - 174 lbs)",
    "80 - 89 kg (176 - 196 lbs)",
    "90 - 99 kg (198 - 218 lbs)",
    "100 - 109 kg (220 - 240 lbs)",
    "110 - 119 kg (242 - 262 lbs)",
    "120 - 129 kg (264 - 284 lbs)",
    "130 - 139 kg (286 - 306 lbs)",
    "140 - 149 kg (308 - 328 lbs)",
    "150 kg+ (330 lbs+)",
  ],
  dietary_preferences: [
    "Vegetarian",
    "Pescetarian",
    "Vegan",
    "Gluten-Free",
    "Dairy-Free",
    "Nut-Free",
    "Kosher",
    "Halal",
    "Mediterranean",
    "Ketogenic (Keto)",
    "Paleo",
    "Intermittent Fasting",
    "Low-Carb",
    "Plant-Based",
    "Raw Food",
  ],
  allergies: [
    "Peanuts",
    "Tree Nuts",
    "Dairy",
    "Eggs",
    "Shellfish",
    "Fish",
    "Soy",
    "Wheat / Gluten",
    "Sesame",
    "Citrus Fruits",
    "Pollen",
    "Dust Mites",
    "Mold & Fungi",
    "Animal Dander",
    "Insect Stings",
    "Latex",
    "Synthetic Fabrics",
    "Detergents & Fabric Softeners",
    "Sports Tape & Adhesives",
    "Sunscreen & Skincare Products",
    "Nickel (Jewelry, Watch Straps, Sports Gear)",
    "NSAIDs",
    "Antibiotics",
    "Local Anesthetics",
    "Muscle Rubs & Recovery Creams",
    "Artificial Sweeteners",
    "Cold Weather Allergy",
    "Hives",
    "Heat Rash",
    "Chlorine Sensitivity",
  ],
  chronic_conditions: [
    "Asthma",
    "Chronic Obstructive Pulmonary Disease (COPD)",
    "Exercise-Induced Bronchoconstriction (EIB)",
    "Hypertension (High Blood Pressure)",
    "Hypotension (Low Blood Pressure)",
    "Arrhythmia (Irregular Heartbeat)",
    "Congenital Heart Disease",
    "Coronary Artery Disease",
    "Peripheral Artery Disease",
    "Diabetes Type 1",
    "Diabetes Type 2",
    "Hypothyroidism",
    "Hyperthyroidism",
    "Polycystic Ovary Syndrome (PCOS)",
    "Osteoarthritis",
    "Rheumatoid Arthritis",
    "Scoliosis",
    "Osteoporosis",
    "Fibromyalgia",
    "Chronic Back Pain",
    "Epilepsy",
    "Multiple Sclerosis (MS)",
    "Parkinson’s Disease",
    "Migraines & Chronic Headaches",
    "Neuropathy",
    "Irritable Bowel Syndrome (IBS)",
    "Crohn’s Disease",
    "Ulcerative Colitis",
    "Acid Reflux (GERD)",
    "Celiac Disease",
    "Lupus",
    "Hashimoto’s Thyroiditis",
    "Sjögren’s Syndrome",
    "Chronic Fatigue Syndrome (CFS/ME)",
    "Depression",
    "Anxiety Disorders",
    "Bipolar Disorder",
    "Post-Traumatic Stress Disorder (PTSD)",
    "Attention Deficit Hyperactivity Disorder (ADHD)",
    "Eczema",
    "Psoriasis",
    "Heat Sensitivity Disorders",
    "Tendonitis",
    "Chronic Muscle Strains",
    "Bursitis",
    "Ehlers-Danlos Syndrome (EDS)",
    "Marfan Syndrome",
    "Sickle Cell Trait/Disease",
  ],
};

export const sportPositions = {
  football_or_soccer: [
    "Goalkeeper",
    "Centre Back",
    "Full Back (Left Back)",
    "Full Back (Right Back)",
    "Defensive Midfielder",
    "Central Midfielder",
    "Central Attacking Midfielder",
    "Winger (Left Wing)",
    "Winger (Right Wing)",
    "Striker (Forward / Center Forward)",
  ],
  basketball: [
    "Point Guard",
    "Shooting Guard",
    "Small Forward",
    "Power Forward",
    "Center",
  ],
  american_football: [
    "Quarterback",
    "Running Back",
    "Wide Receiver",
    "Tight End",
    "Offensive Lineman",
    "Defensive Lineman",
    "Linebacker",
    "Cornerback",
    "Safety",
  ],
  baseball: [
    "Pitcher",
    "Catcher",
    "First Baseman",
    "Second Baseman",
    "Third Baseman",
    "Shortstop",
    "Left Fielder",
    "Center Fielder",
    "Right Fielder",
  ],
  ice_hockey: ["Goaltender", "Defenseman", "Left Wing", "Right Wing", "Center"],
  tennis: [
    "Singles Player",
    "Doubles Player",
    "Serve-and-Volley Player",
    "Baseline Player",
  ],
  rugby: [
    "Prop",
    "Hooker",
    "Lock",
    "Flanker",
    "Number Eight",
    "Scrum-half",
    "Fly-half",
    "Center",
    "Wing",
    "Fullback",
  ],
  cricket: ["Batsman", "Bowler", "Wicketkeeper", "All-rounder"],
  volleyball: [
    "Setter",
    "Outside Hitter",
    "Opposite Hitter",
    "Middle Blocker",
    "Libero",
    "Defensive Specialist",
  ],
};

// Short code mapping for positions
export const sportPositionShortCodes = {
  "Football (Soccer) - Goalkeeper": "GK",
  "Football (Soccer) - Centre Back": "CB",
  "Football (Soccer) - Full Back (Left Back)": "LB",
  "Football (Soccer) - Full Back (Right Back)": "RB",
  "Football (Soccer) - Defensive Midfielder": "CDM",
  "Football (Soccer) - Central Attacking Mid": "CAM",
  "Football (Soccer) - Central Midfielder": "CM",
  "Football (Soccer) - Winger (Left Wing)": "LW",
  "Football (Soccer) - Winger (Right Wing)": "RW",
  "Football (Soccer) - Striker (Forward / Cen": "ST",
  "Basketball - Point Guard": "PG",
  "Basketball - Shooting Guard": "SG",
  "Basketball - Small Forward": "SF",
  "Basketball - Power Forward": "PF",
  "Basketball - Center": "CR",
  "American Football - Quarterback": "QB",
  "American Football - Running Back": "RB",
  "American Football - Wide Receiver": "WR",
  "American Football - Tight End": "TE",
  "American Football - Offensive Lineman": "OL",
  "American Football - Defensive Lineman": "DL",
  "American Football - Linebacker": "LB",
  "American Football - Cornerback": "CB",
  "American Football - Safety": "SY",
  "Baseball - Pitcher": "PR",
  "Baseball - Catcher": "CR",
  "Baseball - First Baseman": "FB",
  "Baseball - Second Baseman": "SB",
  "Baseball - Third Baseman": "TB",
  "Baseball - Shortstop": "SS",
  "Baseball - Left Fielder": "LF",
  "Baseball - Center Fielder": "CF",
  "Baseball - Right Fielder": "RF",
  "Ice Hockey - Goaltender": "GT",
  "Ice Hockey - Defenseman": "DL",
  "Ice Hockey - Left Wing": "LW",
  "Ice Hockey - Right Wing": "RW",
  "Ice Hockey - Center": "CR",
  "Tennis - Singles Player": "SP",
  "Tennis - Doubles Player": "DP",
  "Tennis - Serve-and-Volley Player": "SV",
  "Tennis - Baseline Player": "BL",
  "Rugby - Prop": "PP",
  "Rugby - Hooker": "HK",
  "Rugby - Lock": "LK",
  "Rugby - Flanker": "FR",
  "Rugby - Number Eight": "N8",
  "Rugby - Scrum-half": "SH",
  "Rugby - Fly-half": "FH",
  "Rugby - Center": "CR",
  "Rugby - Wing": "WG",
  "Rugby - Fullback": "FB",
  "Cricket - Batsman": "BM",
  "Cricket - Bowler": "BR",
  "Cricket - Wicketkeeper": "WK",
  "Cricket - All-rounder": "AR",
  "Volleyball - Setter": "SR",
  "Volleyball - Outside Hitter": "OUH",
  "Volleyball - Opposite Hitter": "OPH",
  "Volleyball - Middle Blocker": "MDB",
  "Volleyball - Libero": "LB",
  "Volleyball - Defensive Specialist": "DS",
};

export const DEFAULT_SPORTS_PROFILE_FIELDS = {
  dominant_hand: ["Right", "Left", "Both"],
  dominant_foot: ["Right", "Left", "Both"],
  walking_frequency_over_30mins: [
    "Daily",
    "4-5 times per week",
    "2-3 times per week",
    "Once a week",
    "1-2 times per month",
    "Less than once a month",
  ],
  training_frequency: [
    "Daily",
    "4-5 times per week",
    "2-3 times per week",
    "Once a week",
    "1-2 times per month",
    "Less than once a month",
  ],
  protective_gear_used: [
    "Helmet",
    "Mouthguard",
    "Face Shield",
    "Sports Goggles",
    "Shoulder Pads",
    "Rib Protectors",
    "Arm Sleeves",
    "Elbow Pads",
    "Boxing Gloves",
    "Hand Wraps",
    "Wrist Guards",
    "Finger Tape",
    "Grip Gloves",
    "Shin Guards",
    "Knee Pads",
    "Knee Braces",
    "Padded Compression Shirt",
    "Padded Compression Tights",
    "Ankle Braces",
    "Protective Cup",
    "Cleats",
    "Running Shoes",
    "Court Shoes",
    "Cycling Shoes",
    "Wetsuits",
    "Body Armor",
    "Neck Brace",
    "Chest Protector",
  ],
  preferred_training_style: [
    "Calisthenics",
    "Powerlifting",
    "Functional Strength Training",
    "Resistance Bands Training",
    "Machine-Based training",
    "Long-Distance Running",
    "Sprinting & Speed Work",
    "Cycling",
    "Rowing",
    "Swimming",
    "Jump Rope",
    "Circuit Training",
    "CrossFit",
    "Tabata",
    "Plyometrics",
    "Agility & Footwork Drills",
    "Position-Specific Training",
    "Tactical/Strategic Training",
    "Combat Sports Conditioning",
    "Static Stretching",
    "Dynamic Stretching",
    "Yoga",
    "Pilates",
    "Active Recovery (Low-Intensity Movement)",
    "Foam Rolling & Myofascial Release",
    "Ice Baths & Cold Therapy",
    "Sauna & Heat Therapy",
  ],
  past_sports_injuries: [
    "Concussion",
    "Skull Fracture",
    "Whiplash",
    "Neck Strain",
    "Herniated Disc",
    "Rotator Cuff Tear",
    "Shoulder Dislocation",
    "Shoulder Impingement Syndrome",
    "AC Joint Injury",
    "Labrum Tear",
    "Tennis Elbow",
    "Golfer’s Elbow",
    "Elbow Dislocation",
    "Fractured Arm",
    "Wrist Fracture or Sprain",
    "Boxer’s Fracture",
    "Jammed Finger",
    "Dislocated Finger",
    "Mallet Finger",
    "Jersey Finger",
    "Carpal Tunnel Syndrome",
    "Sciatica",
    "Scoliosis-Related Back Pain",
    "Spinal Fracture",
    "Chronic Lower Back Pain",
    "Hip Labral Tear",
    "Hip Flexor Strain",
    "Hip Dislocation",
    "Groin Strain",
    "Pelvic Stress Fracture",
    "ACL Tear",
    "MCL/LCL Sprain or Tear",
    "Meniscus Tear",
    "Patellar Tendinitis",
    "Runner’s Knee",
    "Shin Splints",
    "Tibia Fracture",
    "Fibula Fracture",
    "Femur Fracture",
    "Calf Strain",
    "Hamstring Tear or Strain",
    "Quadriceps Strain",
    "Ankle Sprain",
    "Achilles Tendon Rupture or Tendinitis",
    "Plantar Fasciitis",
    "Metatarsal Fracture",
    "Turf Toe",
    "Repetitive Stress Injuries",
    "Chronic Joint Pain",
    "Tendinitis",
    "Bursitis",
  ],
  supplements_used: [
    "Whey Protein",
    "Casein Protein",
    "Plant-Based Protein",
    "Egg White Protein",
    "Collagen Protein",
    "Creatine Monohydrate",
    "Creatine Hydrochloride (HCL)",
    "Beta-Alanine",
    "Essential Amino Acids (EAAs)",
    "L-Arginine",
    "L-Citrulline",
    "HMB (Hydroxymethylbutyrate)",
    "Caffeine",
    "Electrolyte Supplements",
    "Adaptogens (Rhodiola Rosea, Ashwagandha)",
    "Nootropic Blends",
    "Omega-3 Fatty Acids",
    "Turmeric",
    "Curcumin",
    "Tart Cherry Extract",
    "CBD Oil",
    "Glucosamine & Chondroitin",
    "MSM (Methylsulfonylmethane)",
    "Collagen Peptides",
    "Calcium & Vitamin D3",
    "L-Carnitine",
    "Green Tea Extract",
    "CLA (Conjugated Linoleic Acid)",
    "Capsaicin",
    "Thermogenic Blends",
    "Multivitamins",
    "Vitamin C",
    "Vitamin D",
    "Magnesium",
    "Zinc",
    "Probiotics",
    "Greens Powders (Superfoods, Spirulina, Chlorella)",
    "Coconut Water Powder",
  ],
};

/** Club and league events share the canonical sports-profile slug. */
export const mapEventTypeToSport = (eventType: string) => {
  if (!eventType) return null;
  const mapping: Record<string, string> = {
    SPORTS_CLUB: "sports",
    FOOTBALL_CLUB: "football_or_soccer",
    TENNIS_CLUB: "tennis",
    SOCCER_CLUB: "football_or_soccer",
    BASKETBALL_CLUB: "basketball",
    SQUASH_CLUB: "squash",
    PADDLE_CLUB: "paddle",
    PADEL_CLUB: "padel",
    AFL_CLUB: "australian_football",
    NFL_CLUB: "american_football",
    RUGBY_CLUB: "rugby",
    BADMINTON_CLUB: "badminton",
    BOXING_CLUB: "boxing",
    CRICKET_CLUB: "cricket",
    ATHLETICS_CLUB: "track_and_field",
    GYMNASTICS_CLUB: "gymnastics",
    CHEERLEADING_CLUB: "cheerleading",
    CYCLING_CLUB: "cycling",
    FENCING_CLUB: "fencing",
    BASEBALL_CLUB: "baseball",
    GOLF_CLUB: "golf",
    KAYAK_CLUB: "kayaking",
    SKIING_CLUB: "skiing",
    DANCING_CLUB: "dancing",
    BOAT_CLUB: "boating",
    BOWLS_CLUB: "bowls",
    CLIMBING_CLUB: "rock_climbing",
    EQUESTRIAN_CLUB: "horse_racing",
    SHOOTING_CLUB: "shooting",
    VOLLEYBALL_CLUB: "volleyball",
    DODGEBALL_CLUB: "dodgeball",
    CHESS_CLUB: "chess",
    SWIMMING_CLUB: "swimming",
    TABLE_TENNIS_CLUB: "table_tennis",
    KARATE_CLUB: "karate",
    TAEKWONDO_CLUB: "taekwondo",
    MUAY_THAI_CLUB: "muay_thai",
    BRAZILIAN_JIUJITSU_CLUB: "brazilian_jiujitsu",
    MMA_CLUB: "mma",
    WRESTLING_CLUB: "wrestling",
    JUDO_CLUB: "judo",
    ARCHERY_CLUB: "archery",
    MOUNTAIN_BIKING_CLUB: "mountain_biking",
    BMX_CLUB: "bmx",
    SKATEBOARDING_CLUB: "skateboarding",
    SURFING_CLUB: "surfing",
    DIVING_CLUB: "diving",
    CANOEING_CLUB: "canoeing",
    ROWING_CLUB: "rowing",
    SAILING_CLUB: "sailing",
    WATER_POLO_CLUB: "water_polo",
    ICE_HOCKEY_CLUB: "ice_hockey",
    FIELD_HOCKEY_CLUB: "field_hockey",
    FIGURE_SKATING_CLUB: "figure_skating",
    ICE_SKATING_CLUB: "ice_skating",
    SNOWBOARDING_CLUB: "snowboarding",
    MARATHON_RUNNING_CLUB: "marathon_running",
    RUNNING_CLUB: "marathon_running",
    HORSE_RACING_CLUB: "horse_racing",
    BOWLING_CLUB: "bowling",
    BILLIARDS_POOL_CLUB: "billiards_pool",
    DARTS_CLUB: "darts",
    RALLY_RACING_CLUB: "rally_racing",
    FORMULA1_CLUB: "formula1",
    MOTOGP_CLUB: "motogp",
    NASCAR_CLUB: "nascar",
    HANDBALL_CLUB: "handball",
    SOFTBALL_CLUB: "softball",
    WATER_SKIING_CLUB: "water_skiing",
  };
  return mapping[eventType.replace(/_LEAGUE$/, "_CLUB")] || null;
};

// --- Helpers for mapping between keyword slugs and display names ---
// Converts a keyword slug (e.g., "football_soccer_centre_back_a5364d65-...") to a display label (e.g., "Centre Back") for a given sport
export function slugToLabel(slug: string, sport: string) {
  if (!slug || !sport) return slug;
  // Try to match by display name (label) in sportPositions
  const positions = sportPositions[sport as keyof typeof sportPositions] || [];
  // If the slug is already a label, return as is
  if (positions.includes(slug)) return slug;
  // Try to find a label that matches the slug (ignoring case, spaces, underscores, dashes)
  const normalized = (str: string) =>
    String(str)
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");
  const slugNorm = normalized(slug);
  for (const label of positions) {
    if (slugNorm.includes(normalized(label))) {
      return label;
    }
  }
  // Fallback: return slug as is
  return slug;
}

export const COUNTRIES = [
  { label: "Argentina", value: "AR", currency: "ARS" },
  { label: "Austria", value: "AT", currency: "EUR" },
  { label: "Andorra", value: "AD", currency: "EUR" },
  { label: "Australia", value: "AU", currency: "AUD" },
  { label: "Belgium", value: "BE", currency: "EUR" },
  { label: "Brazil", value: "BR", currency: "BRL" },
  { label: "Bulgaria", value: "BG", currency: "BGN" },
  { label: "Canada", value: "CA", currency: "CAD" },
  { label: "Chile", value: "CL", currency: "CLP" },
  { label: "China", value: "CN", currency: "CNY" },
  { label: "Colombia", value: "CO", currency: "COP" },
  { label: "Costa Rica", value: "CR", currency: "CRC" },
  { label: "Croatia", value: "HR", currency: "EUR" },
  { label: "Czech Republic", value: "CZ", currency: "CZK" },
  { label: "Denmark", value: "DK", currency: "DKK" },
  { label: "Ecuador", value: "EC", currency: "USD" },
  { label: "Egypt", value: "EG", currency: "EGP" },
  { label: "El Salvador", value: "SV", currency: "USD" },
  { label: "Estonia", value: "EE", currency: "EUR" },
  { label: "Finland", value: "FI", currency: "EUR" },
  { label: "France", value: "FR", currency: "EUR" },
  { label: "Germany", value: "DE", currency: "EUR" },
  { label: "Greece", value: "GR", currency: "EUR" },
  { label: "Guatemala", value: "GT", currency: "GTQ" },
  { label: "Honduras", value: "HN", currency: "HNL" },
  { label: "Hungary", value: "HU", currency: "HUF" },
  { label: "India", value: "IN", currency: "INR" },
  { label: "Indonesia", value: "ID", currency: "IDR" },
  { label: "Ireland", value: "IE", currency: "EUR" },
  { label: "Israel", value: "IL", currency: "ILS" },
  { label: "Italy", value: "IT", currency: "EUR" },
  { label: "Japan", value: "JP", currency: "JPY" },
  { label: "Kazakhstan", value: "KZ", currency: "KZT" },
  { label: "Kenya", value: "KE", currency: "KES" },
  { label: "Malaysia", value: "MY", currency: "MYR" },
  { label: "Mexico", value: "MX", currency: "MXN" },
  { label: "Netherlands", value: "NL", currency: "EUR" },
  { label: "New Zealand", value: "NZ", currency: "NZD" },
  { label: "Nigeria", value: "NG", currency: "NGN" },
  { label: "Norway", value: "NO", currency: "NOK" },
  { label: "Pakistan", value: "PK", currency: "PKR" },
  { label: "Peru", value: "PE", currency: "PEN" },
  { label: "Philippines", value: "PH", currency: "PHP" },
  { label: "Poland", value: "PL", currency: "PLN" },
  { label: "Portugal", value: "PT", currency: "EUR" },
  { label: "Qatar", value: "QA", currency: "QAR" },
  { label: "Romania", value: "RO", currency: "RON" },
  { label: "Russia", value: "RU", currency: "RUB" },
  { label: "Saudi Arabia", value: "SA", currency: "SAR" },
  { label: "Singapore", value: "SG", currency: "SGD" },
  { label: "South Africa", value: "ZA", currency: "ZAR" },
  { label: "South Korea", value: "KR", currency: "KRW" },
  { label: "Spain", value: "ES", currency: "EUR" },
  { label: "Sweden", value: "SE", currency: "SEK" },
  { label: "Switzerland", value: "CH", currency: "CHF" },
  { label: "Taiwan", value: "TW", currency: "TWD" },
  { label: "Turkey", value: "TR", currency: "TRY" },
  { label: "United Kingdom", value: "UK", currency: "GBP" },
  { label: "United States of America", value: "US", currency: "USD" },
  { label: "Vietnam", value: "VN", currency: "VND" },
];

export const sportsClubTypes = [
  "SPORTS_CLUB",
  "FOOTBALL_CLUB",
  "TENNIS_CLUB",
  "SOCCER_CLUB",
  "BASKETBALL_CLUB",
  "SQUASH_CLUB",
  "PADDLE_CLUB",
  "AFL_CLUB",
  "NFL_CLUB",
  "RUGBY_CLUB",
  "BADMINTON_CLUB",
  "BOXING_CLUB",
  "CRICKET_CLUB",
  "ATHLETICS_CLUB",
  "GYMNASTICS_CLUB",
  "CHEERLEADING_CLUB",
  "CYCLING_CLUB",
  "FENCING_CLUB",
  "BASEBALL_CLUB",
  "GOLF_CLUB",
  "KAYAK_CLUB",
  "SKIING_CLUB",
  "DANCING_CLUB",
  "BOAT_CLUB",
  "BOWLS_CLUB",
  "CLIMBING_CLUB",
  "EQUESTRIAN_CLUB",
  "SHOOTING_CLUB",
  "VOLLEYBALL_CLUB",
  "DODGEBALL_CLUB",
  "CHESS_CLUB",
  "SWIMMING_CLUB",
  "TABLE_TENNIS_CLUB",
  "KARATE_CLUB",
  "TAEKWONDO_CLUB",
  "MUAY_THAI_CLUB",
  "BRAZILIAN_JIUJITSU_CLUB",
  "MMA_CLUB",
  "WRESTLING_CLUB",
  "JUDO_CLUB",
  "ARCHERY_CLUB",
  "MOUNTAIN_BIKING_CLUB",
  "BMX_CLUB",
  "SKATEBOARDING_CLUB",
  "SURFING_CLUB",
  "DIVING_CLUB",
  "CANOEING_CLUB",
  "ROWING_CLUB",
  "SAILING_CLUB",
  "WATER_POLO_CLUB",
  "ICE_HOCKEY_CLUB",
  "FIELD_HOCKEY_CLUB",
  "FIGURE_SKATING_CLUB",
  "ICE_SKATING_CLUB",
  "SNOWBOARDING_CLUB",
  "MARATHON_RUNNING_CLUB",
  "HORSE_RACING_CLUB",
  "BOWLING_CLUB",
  "BILLIARDS_POOL_CLUB",
  "DARTS_CLUB",
  "RALLY_RACING_CLUB",
  "FORMULA1_CLUB",
  "MOTOGP_CLUB",
  "NASCAR_CLUB",
  "HANDBALL_CLUB",
  "SOFTBALL_CLUB",
  "WATER_SKIING_CLUB",
];
